// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"3931388c76a0d16b","758":"75468f2875dd4fae","895":"9d0dda9db2657eb1"}[chunkId] + ".js";
};